/**
 * @file helper.class.js
 * @description Defines static functions that are used throughout classes.
 */

class Helper {

  /**
   * @description Returns the elements height including padding, margin, and border;
   * @param {node} element 
   */
  static getHeight(element) {
    let style = element.currentStyle || window.getComputedStyle(element);
    let height = element.clientHeight;
    let margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    let padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    let border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    return height + margin + padding + border;
  }

  /**
   * @description Gets the transition duration
   * @param {Node} element 
   * @param {boolean} inMilliseconds If true returns the transition duration in milliseconds.
   * @returns 
   */
  static getTransitionDuration(element, inMilliseconds) {
    let computedStyle = window.getComputedStyle(element);
    let transitionDuration = computedStyle.transitionDuration.replace(/[^0-9.]/g, '');
    if (inMilliseconds) return transitionDuration * 1000;
    return transitionDuration;
  }

  /**
   * @description Set the transition duration
   * @param {*} $element 
   */
  static setTransitionDuration(element, duration) {
    element.style.transitionDuration = duration;
  }

  /**
   * @description Toggles the specified class on the passed element.
   * @param {Node} element 
   * @param {string} className 
   */
  static toggleClass(element, className) {
    if (element.classList.contains(className)) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  /**
   * @description Selects the node based on the passed selector. Returns false if the element is not found.
   * @param {string} selector 
   * @returns Node
   */
  static getElement(selector) {
    return document.querySelector(selector) !== null ? document.querySelector(selector) : false;
  }

    /**
   * @description Selects the nodes based on the passed selector. Returns false if the element is not found.
   * @param {string} selector 
   * @returns Node list
   */
  static getElements(selector) {
    return document.querySelectorAll(selector) !== null ? document.querySelectorAll(selector) : false;
  }

  /**
   * Looks for the passed cookie by name & if found, returns it.
   * @param {String} name 
   */
  static getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
  }

  /**
   * Returns the value of the passed query parameter.
   * @param {String} name 
   * @param {String} url 
   */
  static getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * Checks whether the current client is using Internet Explorer
   */
  static isInternetExplorer() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
  
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
      {
          return true;
      }
  
      return false;
  }
}